<template>
	<div>
		<div>
			<div class="logged_in">
				<div v-if="0" class="help mr_20">
					<a @click="tutorialHandler">
						<span class="blind">도움말</span>
					</a>
				</div>
				<div class="user_name logged_in_user_area">
					<a class="logged_in_user" @click="toggleUserMenu">
						<div
							:class="[{ active: userLow }, 'icon', 'icon_user', 'mr_10']"
						></div>
						<p>{{ $store.state.auth.member_info.user_name }}</p>
					</a>
					<ul class="user_name_dropdown" v-if="userLow">
						<li>
							<a @click="merchantMenuHandler">{{
								$t('menu.merchant.merchant')
							}}</a>
						</li>
						<li v-for="item in user_menu" :key="item.name">
							<router-link :to="{ name: item.name }">{{
								$t('menu.' + item.title)
							}}</router-link>
						</li>
						<li>
							<a @click.prevent="logoutHandler">{{ $t('menu.logout') }}</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<ModalHelp v-if="helpModal" @closeModal="closeHelpModal">
			<h2 class="title">{{ $t('help.title') }}</h2>
			<div class="search_area mb_20">
				<input
					type="text"
					:placeholder="$t('input.placeholder.search')"
					v-model="helpSearchKeyword"
				/>
				<a class="search_icon SEARCH"></a>
			</div>
			<div class="help_question">
				<p class="mb_20 fw_bold">{{ $t('help.title1') }}</p>
				<div class="help_item" v-for="(item, idx) in nowMenuHelp" :key="idx">
					<p class="mb_10">{{ $t(item.Q) }}</p>
					<p class="fc_red">{{ $t(item.A) }}</p>
				</div>
			</div>
		</ModalHelp>
	</div>
</template>

<script>
import ModalHelp from '@/components/Layout/ModalHelp';
export default {
	name: 'menuMy',
	components: {
		ModalHelp,
	},
	data() {
		return {
			setting_menu: [
				{ title: 'setting-security', name: 'setting-security' },
				{ title: 'setting-payment', name: 'setting-payment' },
				{ title: 'setting-notice', name: 'setting-notice' },
			],
			user_menu: [
				// { title: 'merchant-catalog', name: 'merchant-console-catalog' },
				{ title: 'mypage-account', name: 'mypage-account' },
				// { title: 'mypage-data', name: 'mypage-data' },
				{ title: 'mypage-certification', name: 'mypage-certification' },
				// { title: 'mypage-seller_tool', name: 'mypage-seller_tool' },
			],
			settingLow: false,
			userLow: false,
			helpSearchKeyword: '',
			helpModal: false,
			helpSampleDataList: {
				'auth-dashboard': [
					{
						Q: 'help.q1',
						A: 'help.a1',
					},
					{
						Q: 'help.q2',
						A: 'help.a2',
					},
				],
				'pay-payment': [
					{
						Q: 'help.q3',
						A: 'help.a3',
					},
					{
						Q: 'help.q4',
						A: 'help.a4',
					},
				],
				'pay-deposit': [
					{
						Q: 'help.q5',
						A: 'help.a5',
					},
					{
						Q: 'help.q6',
						A: 'help.a6',
					},
				],
				'pay-contacts': [
					{
						Q: 'help.q7',
						A: 'help.a7',
					},
				],
				'wallet_account-assets': [
					{
						Q: 'help.q8',
						A: 'help.a8',
					},
					{
						Q: 'help.q9',
						A: 'help.a9',
					},
				],
				activity: [
					{
						Q: 'help.q10',
						A: 'help.a10',
					},
					{
						Q: 'help.q11',
						A: 'help.a11',
					},
				],
				'mypage-account': [
					{
						Q: 'help.q12',
						A: 'help.a12',
					},
					{
						Q: 'help.q13',
						A: 'help.a13',
					},
				],
				'mypage-data': [
					{
						Q: 'help.q14',
						A: 'help.a14',
					},
					{
						Q: 'help.q15',
						A: 'help.a15',
					},
				],
				'merchant-console-catalog': [
					{
						Q: 'help.q16',
						A: 'help.a16',
					},
					{
						Q: 'help.q17',
						A: 'help.a17',
					},
				],
				'merchant-console-transaction-list': [
					{
						Q: 'help.q18',
						A: 'help.a18',
					},
				],
				cs: [
					{
						Q: 'help.q19',
						A: 'help.a19',
					},
				],
				certification: [
					{
						Q: 'help.q20',
						A: 'help.a20',
					},
					{
						Q: 'help.q21',
						A: 'help.a21',
					},
				],
			},
		};
	},
	computed: {
		nowMenuHelp() {
			let result;
			if (this.$route.name.includes('cs')) {
				result = this.helpSampleDataList.cs;
			} else if (this.$route.name.includes('certification')) {
				result = this.helpSampleDataList.certification;
			} else {
				result = this.helpSampleDataList[this.$route.name];
			}
			if (!this.helpSearchKeyword) {
				return result;
			} else {
				return result.filter(item => {
					return this.$t(item.Q)
						.replaceAll(' ', '')
						.toLowerCase()
						.includes(this.helpSearchKeyword.replaceAll(' ', '').toLowerCase());
				});
			}
		},
		currentRoute() {
			return this.$route.name;
		},
	},
	methods: {
		logoutHandler() {
			let logout_confirm = confirm(this.$t('alert.logout'));
			if (logout_confirm) {
				this.$store.dispatch('auth/logout');
				this.$router.push({ name: 'home' });
			}
		},
		merchantMenuHandler() {
			this.$emit('showMerchantPicker');
		},
		toggleUserMenu() {
			this.userLow = !this.userLow;
			this.settingLow = false;
		},
		closeHelpModal() {
			this.helpModal = false;
			this.helpSearchKeyword = '';
		},
		tutorialHandler() {
			if (this.currentRoute === 'auth-dashboard') {
				this.$emit('showTutorial');
			} else if (this.currentRoute === 'pay-payment') {
				this.$emit('showTutorial');
			} else if (this.currentRoute === 'pay-deposit') {
				this.$emit('showTutorial');
			} else if (this.currentRoute === 'pay-exchange') {
				this.$emit('showTutorial');
			} else if (this.currentRoute === 'pay-c2c') {
				this.$emit('showTutorial');
			} else {
				this.helpModal = true;
			}
		},
	},
};
</script>
<style scoped>
.help_question p {
	font-size: 18px;
}
.help_item {
	padding-bottom: 10px;
	border-bottom: 1px solid #999;
	margin-bottom: 10px;
}
</style>
